import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { VideoErrorComponent } from '../../media/video-error/video-error.component';
import { VideoPlayerComponent } from '../../media/video-player/video-player.component';
import { PresentationController } from '../../presentation-controller';
import { SlideLayoutConfigService } from '../../slide-layout-config.service';

const SCHEDULED_VIDEO_RETRY_LIMIT = 12;

@Component({
  selector: 'ds-video-layout',
  imports: [VideoPlayerComponent, VideoErrorComponent],
  templateUrl: './video-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoLayoutComponent {
  private readonly config = inject(SlideLayoutConfigService);

  public readonly controller = input.required<PresentationController>();
  public readonly slide = computed(() => this.controller().slide);
  public readonly videoId = computed(() => this.slide().content.videoId ?? '');
  public readonly isLive = computed(() => this.slide().kind === 'youtube-live');
  public readonly retryLimit = computed(() => this.isLive() ? 20 : SCHEDULED_VIDEO_RETRY_LIMIT);
  public readonly closedCaptions = this.config.closedCaptions;
}
